import React, { useState } from "react";
import { Form, Input, message } from "antd";
import Popup from "../common/Popup";
import { useCreateCohort } from "../../api/CohortsAPI";
import { useAuth } from "../../context/AuthContext";

const CreateCohortModal = ({ isOpen, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();
  const createCohortMutation = useCreateCohort();

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      
      await createCohortMutation.mutateAsync({
        authorId: currentUser.id,
        name: values.name || null
      });
      
      message.success("Cohort created successfully");
      form.resetFields();
      onClose();
    } catch (error) {
      console.error("Error creating cohort:", error);
      message.error("Failed to create cohort");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Popup
      open={isOpen}
      title="Create New Cohort"
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      onOk={handleSubmit}
      footer={[
        <button
          key="cancel"
          onClick={() => {
            form.resetFields();
            onClose();
          }}
          className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded mr-2"
        >
          Cancel
        </button>,
        <button
          key="submit"
          onClick={handleSubmit}
          disabled={loading}
          className="bg-primary hover:bg-primaryLight text-white font-semibold py-2 px-4 rounded"
        >
          {loading ? "Creating..." : "Create Cohort"}
        </button>
      ]}
      content={
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Cohort Name"
            rules={[
              {
                max: 100,
                message: "Cohort name cannot exceed 100 characters",
              },
            ]}
          >
            <Input 
              placeholder="Enter cohort name (optional)" 
              maxLength={100}
            />
          </Form.Item>
          <p className="text-gray-500 text-sm">
            If no name is provided, the cohort will be labeled as "Untitled Cohort"
          </p>
        </Form>
      }
    />
  );
};

export default CreateCohortModal;
